module.exports = __webpack_public_path__ + "img/image-03-sp.d04c1b08.jpg";